import React, { useEffect, useState } from 'react';
import './ValidationReferenceNotFoundModal.scss';

import { faArrowLeft, faArrowRight, faCheck, faClose, faTrashCan, faWarning } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CURRENCY from 'utils/constants/currency';
import { useForm } from 'react-hook-form';
import { notify } from 'utils/marketplace';
import { IRefOrder } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';
import Pagination from 'components/pagination/Pagination';
import IconItem from 'components/Item/IconItem/IconItem';

import { useDispatch } from 'react-redux';
import { setCloseModal } from 'store/slices/proformaAutomotorModal.slice';
import { formatNumberWithSpaces } from 'utils/utils';
import ActionContentElement from './ActionContent/ActionContentElement';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};

type IRowTable = {
  [key: string]: string | number | null | { totalPrice: string; index: number };
};

type FormValues = {
  'checkbox-ref': string[];
  'checkbox-ref-all': boolean;
};
const ValidationReferenceNotFoundModal: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [data, setData] = useState<Array<IRefOrder>>([]);
  const [showTableReferenceNotFound, setShowTableReferenceNotFound] = useState(false);
  const user = JSON.parse(localStorage.getItem('userData')!);

  const { setValue, register, getValues, watch, reset } = useForm<FormValues>({
    defaultValues: {
      'checkbox-ref': [],
      'checkbox-ref-all': false,
    },
  });

  const [dataPagination, setDataPagination] = useState<Array<IRefOrder>>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage] = useState<number>(5);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [validatePressedRows, setValidatePressedRows] = useState<string[]>([]);
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };


  useEffect(() => {
    if (props.stepModalNext === 'ValidationReferencesNotFound') {
      const referenceNotFound = proformaFile?.rows?.filter((row) => row.section === 'REFERENCE_NOT_FOUND');

      const data = referenceNotFound.reduce((rows: Array<IRowTable>, row, currentIndex) => {
        const qte = +(row.data[6] as number);

        const data = {
          reference: row.data[4],
          brand: 'brand1',
          file_price: row.info?.price_from_file ? `${formatNumberWithSpaces(Number(row.info?.price_from_file).toFixed(2))} ${CURRENCY[user!.currency]}` : (row.data[7] ? `${formatNumberWithSpaces(Number(row.data[7]).toFixed(2))} ${CURRENCY[user!.currency]}` : '-'),
          sell_price: row.info?.current_price ? `${formatNumberWithSpaces(Number(row.info?.current_price).toFixed(2))} ${CURRENCY[user!.currency]}` : '-',
          qte: qte,
          description: (row.info?.description ? row.info?.description : row.data[5]),
          total: {
            totalPrice: `${CURRENCY[user!.currency]}${row.info?.current_price * qte}`,
            index: currentIndex,
          },
          supplier_name: row.info?.supplier_name ? row.info?.supplier_name : '-',
          index: row.data[0],
          reference_internal: row.data[2],

        };

        rows.push(data);

        return rows;
      }, []);

      setData(data);
    }

  }, [props.stepModalNext]);

  useEffect(() => {
    if (data.length > 0) {
      const total = data.length;

      setTotalPages(Math.ceil(total / itemsPerPage));
      const startIndex = (currentPage - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;

      setDataPagination(data.slice(startIndex, endIndex));
    }


  }, [data, currentPage, itemsPerPage]);

  const handlePageClick = (page: number) => {
    setCurrentPage(page);
    reset();
    setShowDeleteAll(false);
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;

    setShowDeleteAll(isChecked);

    if (isChecked) {
      setValue('checkbox-ref', dataPagination?.map((item) => String(item.reference + '-' + item.index)));
    }
    else {
      setValue('checkbox-ref', []);
    }
  };

  const handleDeleteSelected = () => {

    let items;


    if (Array.isArray(getValues()['checkbox-ref'])) {
      items = getValues()['checkbox-ref']?.map(String);
    } else {
      items = [Number(getValues()['checkbox-ref'])];
    }

    if (items && items.length === 0) {
      notify(t('_no_data'), 'error', t('_error'));

      return;
    }

    const dataTable = data.filter((row) => !items.includes(row.reference + '-' + row.index));

    const updatedRows = proformaFile.rows.filter((row) => !items.includes(String(row.data[4]) + '-' + String(row.data[0])));

    const updatedProformaFile = {
      ...proformaFile,
      count: proformaFile.count - items.length,
      rows: updatedRows
    };

    localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProformaFile));
    setData(dataTable);
    setValue('checkbox-ref', []);
    notify(t('_references_deleted'), 'success', t('_success'));
    setShowDeleteAll(false);

    setValidatePressedRows(prev =>
      prev.filter(item => !items.map(i => i.replace(/-/g, '')).includes(item))
    );

    setValue('checkbox-ref-all', false);

    if (currentPage === 1) {
      setCurrentPage(currentPage);
    }
    else if (currentPage > Math.ceil(dataTable.length / itemsPerPage)) {
      setCurrentPage(Math.ceil(dataTable.length / itemsPerPage));
    } else {
      setCurrentPage(currentPage);
    }

    if (dataTable.length === 0) {
      props.setStepModal('ValidationReferencesPriceNotOK');
    }
  };

  const show = (id: string, type, event: React.MouseEvent) => {
    event.stopPropagation();
    const el = document.getElementById(String(id));

    if (el) {
      el.style.display = type;
    }
  };

  useEffect(() => {
    if (getValues()['checkbox-ref']?.length > 0) {
      if (getValues()['checkbox-ref']?.length === dataPagination.length) {
        setValue('checkbox-ref-all', true);
      }
      else {
        setValue('checkbox-ref-all', false);
      }
    } else {
      setValue('checkbox-ref-all', false);
    }
  }, [watch('checkbox-ref')]);

  const deleteAllItems = () => {
    const referencesNew = proformaFile?.rows?.filter(
      (row) => !(row.section === 'REFERENCE_NOT_FOUND' && row.replaceRef !== true)
    );

    const updatedProformaFile = {
      ...proformaFile,
      count: proformaFile.count - referencesNew.length,
      rows: referencesNew
    };

    localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProformaFile));

    setValue('checkbox-ref', []);
    notify(t('_references_deleted'), 'success', t('_success'));
    setShowDeleteAll(false);
    setValidatePressedRows([]);
    setValue('checkbox-ref-all', false);

    // Execută addNewReferance într-un pas următor
    setTimeout(() => {
      addNewReferance(true);
    }, 0);


  };


  const addNewReferance = (isDeleted = false) => {

    if (validatePressedRows.length != data.length && !isDeleted) {
      notify(t('_validation_ref_not_found_message_error'), 'error', t('_error'));

      return;
    }


    if (validatePressedRows.length > 0) {

      const referencesNew = proformaFile?.rows?.filter((row) => (row.section === 'REFERENCE_NOT_FOUND' && row.replaceRef === true));

      const partsValid = proformaFile.partsWithReplacements;


      referencesNew.forEach((newItem) => {


        const existingIndex = partsValid.findIndex((item) => {
          return item.code_fou === newItem.newRef.code_fou;
        });

        if (existingIndex !== -1) {

          const indexRow = partsValid[existingIndex].parts.length;

          newItem.newRef.parts[0].index = indexRow;
          newItem.newRef.parts[0].supplier_name = newItem.newRef.parts[0].name;
          partsValid[existingIndex].parts = Array.from(new Set([...partsValid[existingIndex].parts, newItem.newRef.parts[0]]));


        } else {

          newItem.newRef.parts[0].supplier_name = newItem.newRef.parts[0].name;
          partsValid.push(newItem.newRef);
        }


      });


      const updatedProformaFile = {
        ...proformaFile,
        count: proformaFile.count + referencesNew.length,
        partsWithReplacements: partsValid,
        rows: proformaFile?.rows?.filter((row) => (row.replaceRef !== true))
      };

      localStorage.setItem('proformaFileInProgress', JSON.stringify(updatedProformaFile));

      setData(data.filter((row) => row.replaceRef !== true));

      if (data.filter((row) => row.replaceRef !== true).length > 0 && !isDeleted) {
        props.setStepModal('ValidationReferencesNotFoundComment');
      } else {
        props.setStepModal('ValidationReferencesPriceNotOK');

      }

      return;
    }

    if (isDeleted) {
      props.setStepModal('ValidationReferencesPriceNotOK');


    } else {

      props.setStepModal('ValidationReferencesNotFoundComment');
    }

  };


  return (
    <div className="validation-custumer-order-modal" >
      <div className="close upload_order_info_reference_not_found_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>

      {!showTableReferenceNotFound ? (
        <div className="validation-customer-modal-body">
          <div className="validation-customer-modal-row">
            <div className="validation-customer-modal-title">{t('_verification_and_analysis_of_your_order')}</div>
            <div className="validation-customer-modal-subtitle">
              <div>
                <FontAwesomeIcon icon={faWarning} className="validation-customer-modal-icon" />
              </div>
              <div>{t('_warning_message')}</div>
              <DefaultButton className="validation-customer-modal-reference-btn upload_order_info_reference_not_found_show_list" text={t('_btn_see_non_compliant_references')} onClick={() => { setShowTableReferenceNotFound(true); }} />

            </div>
          </div>
          <div className="validation-customer-modal-row">
            <div className="validation-customer-modal-button">
              {/* <DefaultButton className="validation-customer-modal-btn upload_order_info_reference_not_found_add_to_estimation" text={t('_send_the_order_reference_not_found')} onClick={() => { props.setStepModal('ValidationReferencesNotFoundComment'); }} /> */}
              <DefaultButton className="validation-customer-modal-btn upload_order_info_reference_not_found_add_to_estimation" text={t('_send_the_order_reference_not_found')} onClick={() => { setShowTableReferenceNotFound(true); }} />
              <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_reference_not_found_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />

            </div>

          </div>

        </div>
      ) : (
        <div className="validation-customer-modal-body">
          <div className="validation-customer-modal-row">
            <div className="validation-customer-modal-title">{t('_reference_checks')}</div>
            <div className="validation-customer-modal-subtitle">
              <Trans
                i18nKey="_reference_checks_message"
                components={{ bold: <br /> }}

              />
            </div>
            <div className="validation-customer-modal-row">
              <div className="div-select-all">
                {
                  showDeleteAll && getValues()['checkbox-ref']?.length ?
                    <div className="btn-delete">
                      <button onClick={(event) => show('deleteALL', 'block', event)}><FontAwesomeIcon icon={faTrashCan} /> {t('_delete_selected_this_page')}</button>
                      <div className="tooltip-order-select-all"
                        id={String('deleteALL')}
                        onMouseLeave={(event) =>
                          setTimeout(() => {
                            show(String('deleteALL'), 'none', event);
                          }, 100)
                        }
                      >
                        <div className="tooltip_lable">
                          <button className="yes" onClick={() => handleDeleteSelected()}><FontAwesomeIcon icon={faCheck} /> {t('_yes')}</button>
                          <button className="no" onClick={(event) => show('deleteALL', 'none', event)}><FontAwesomeIcon icon={faClose} /> {t('_no')}</button>
                        </div>
                      </div>
                    </div>
                    : null
                }

              </div>
              <table className="validation-customer-modal-table">
                <thead>
                  <tr >
                    <th className="checkbox"  > <input type="checkbox" {...register('checkbox-ref-all')} onChange={handleSelectAll} /> </th>
                    <th className="text-align-left"> {t('_reference')} / {t('_description')}</th>
                    <th >{t('_quantity_order')}</th>
                    <th >{t('_price_u')}</th>
                    <th  >{t('_ref_new')}</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    dataPagination.map((row) => (
                      <tr key={row.reference + row.index}>
                        <td className="checkbox"> <input type="checkbox" key={row.reference + row.index} id={row.reference + row.index} {...register('checkbox-ref')} value={row.reference + '-' + row.index} /></td>
                        <td className="text-align-left">{row.description ? `${row.reference ?? ''} / ${row.description}` : row.reference ?? ''}</td>
                        <td>{row.qte}</td>
                        <td>{row.file_price}</td>
                        <td className="action">
                          <ActionContentElement
                            itemsPerPage={itemsPerPage}
                            setCurrentPage={setCurrentPage}
                            currentPage={currentPage}
                            index={row.index!}
                            item={row}
                            rowsData={data}
                            setData={setData}
                            setValidatePressedRows={setValidatePressedRows}
                            validatePressedRows={validatePressedRows}
                            setStepModal={props.setStepModal}
                          />
                        </td>

                      </tr>)))
                    :
                    <tr>
                      <td colSpan={5} className="no-data">{t('_no_data')}</td>
                    </tr>
                  }


                </tbody>
              </table>

              {totalPages > 1 && (
                <Pagination pageCount={totalPages} handlePageClick={handlePageClick} forcePage={currentPage} hiddenParamPage iconsPrevious={faArrowLeft} iconsNext={faArrowRight} />
              )}
            </div>
            <div className="validation-customer-modal-row">
              <div className="validation-customer-modal-button">
                <button className="default-button validation-customer-modal-btn upload_order_info_reference_not_found_list_add_to_estimation" onClick={() => { addNewReferance(); }} ><FontAwesomeIcon icon={faCheck} />  {t('_confirm_my_order_with_the_new_references')}</button>
                <DefaultButton className="validation-customer-modal-btn upload_order_info_reference_not_found_delete_all_items" text={t('_delete_all_items')} onClick={() => { deleteAllItems(); }} />
                <DefaultButton className="validation-customer-modal-btn cancel upload_order_info_reference_not_found_list_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />
              </div>
            </div>
          </div>
        </div>
      )
      }

    </div >
  );
};

ValidationReferenceNotFoundModal.displayName = 'ValidationReferenceNotFoundModal';

export default ValidationReferenceNotFoundModal;